import * as React from "react";

import {NotAllowedBlock} from "@components";

export default function numColumn(name, label) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value) => {
                return <>
                    {!value && <NotAllowedBlock />}
                    {value}
                </>
            }
        }
    }
}